/**
 * Words for people, from the keys the data files use.
 *
 * The data names things in camelCase ("animalHandling", "lawfulGood"); a player should
 * never read one. This is display only: whatever is sent to the server stays the key,
 * because the server looks things up by it and a label sent back would be a name it has
 * never heard of.
 *
 * `optionLabel` (characters/options.ts) is the sentence-case sibling ("Half elf") used for
 * races and classes; this is Title Case, for names that read as titles.
 */

const LOWER_WORDS = new Set(['and', 'of', 'the']);

/** "animalHandling" -> "Animal Handling", "setSnaresAndTraps" -> "Set Snares and Traps". */
export function titleLabel(key: string): string {
  return key
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .split(' ')
    .filter((word) => word !== '')
    .map((word, index) =>
      index > 0 && LOWER_WORDS.has(word.toLowerCase())
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1),
    )
    .join(' ');
}
